// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2EhTu","col":"styles_col__1_J4I","actions":"styles_actions__3iMut","conflict":"styles_conflict__16j2J"};